import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import { UpdateUrlInput, UpdateUrlMutation } from '@/gql/graphql';

const UPDATE_URL_MUTATION = graphql(`
  mutation UpdateUrl($input: UpdateUrlInput!) {
    updateUrl(input: $input)
  }
`);

const useUpdateUrl = (
  options?: UseMutationOptions<UpdateUrlMutation, unknown, UpdateUrlInput>
) => {
  return useMutation({
    mutationFn: (input) => {
      return gqlClient.request(UPDATE_URL_MUTATION, { input });
    },
    ...options,
  });
};

export default useUpdateUrl;
